import React from 'react'
import FoodContainer from "./FoodContainer"

const FoodCreate = () => {
  return (
    <div className='page-body'>
      <FoodContainer />
    </div>
  )
}

export default FoodCreate